import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-casto-confirm-forgotten-password',
  templateUrl: './confirm-forgotten-password.component.html',
})
export class ConfirmForgottenPasswordComponent {
  constructor(public modalService: ModalService) {}
}
